module.exports = __webpack_public_path__ + "img/notros.3b02a5a9.svg";